<template>
  <v-dialog
    v-model="internalDialog"
    max-width="400px"
    content-class="no-scroll"
  >
    <v-card class="pa-2 dialog-select rounded-card elevation-3">
      <v-col cols="12" class="py-2 text-center">
        <span class="title-text">รู้จักเราผ่านช่องทางไหน</span>
      </v-col>

      <v-img :src="faqGroupImage()" height="100px" contain class="mx-auto" />

      <v-form ref="form">
        <v-list class="list-container ma-3">
          <v-list-item
            v-for="(option, index) in referralSources"
            :key="index"
            class="list-item"
            dense
          >
            <v-row no-gutters align="center">
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="selectedOptions"
                  :label="option.referral_source"
                  @change="clearAdditionalInfo"
                  :value="option.id"
                  class="custom-checkbox"
                  dense
                  color="#03baa6"
                  hide-details="auto"
                ></v-checkbox>
              </v-col>
              <v-col cols="12 my-2" sm="6">
                <v-text-field
                  v-if="selectedOptions.includes(7) && option.id === 7"
                  v-model="additionalInfo.recommend"
                  placeholder="ระบุ"
                  dense
                  outlined
                  hide-details="auto"
                  class="custom-text-field"
                />

                <span
                  v-if="
                    showErrors &&
                    selectedOptions.includes(7) &&
                    option.id === 7 &&
                    !additionalInfo.recommend
                  "
                  class="error-text"
                >
                  กรุณาระบุข้อมูล
                </span>
                <span
                  v-if="
                    selectedOptions.includes(7) &&
                    option.id === 7 &&
                    additionalInfo.recommend &&
                    additionalInfo.recommend.length > 100
                  "
                  class="error-text"
                >
                  กรุณากรอกไม่เกิน 100 ตัวอักษร
                </span>
                <v-text-field
                  v-if="selectedOptions.includes(8) && option.id === 8"
                  v-model="additionalInfo.other"
                  placeholder="ระบุ"
                  dense
                  outlined
                  hide-details="auto"
                  class="custom-text-field"
                />
                <span
                  v-if="
                    showErrors &&
                    selectedOptions.includes(8) &&
                    option.id === 8 &&
                    !additionalInfo.other
                  "
                  class="error-text"
                >
                  กรุณาระบุข้อมูล
                </span>
                <span
                  v-if="
                    selectedOptions.includes(8) &&
                    option.id === 8 &&
                    additionalInfo.other &&
                    additionalInfo.other.length > 100
                  "
                  class="error-text"
                >
                  กรุณากรอกไม่เกิน 100 ตัวอักษร
                </span>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-form>

      <div class="pt-2 text-center">
        <v-btn
          class="confirm-button"
          @click="submit"
          :disabled="isSubmitDisabled"
        >
          ตกลง
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FaqDialog",
  props: {
    show: Boolean,
  },
  emits: ["close"],

  data() {
    return {
      internalDialog: this.show,
      selectedOptions: [],
      additionalInfo: {
        recommend: "",
        other: "",
      },
      showErrors: false,
    };
  },
  computed: {
    ...mapGetters({
      referralSources: "referralSources",
      business_id: "business_id",
    }),
    isSubmitDisabled() {
      return (
        (this.selectedOptions.includes(7) &&
          this.additionalInfo.recommend.length > 100) ||
        (this.selectedOptions.includes(8) &&
          this.additionalInfo.other.length > 100)
      );
    },
  },
  watch: {
    show(newVal) {
      this.internalDialog = newVal;
    },
    internalDialog(newVal) {
      if (!newVal) {
        this.$emit("close");
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.selectedOptions = [];
      this.additionalInfo = {
        recommend: "",
        other: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    faqGroupImage() {
    return process.env.VUE_APP_USE_THEME === "SPU_ADMIN"
      ? require("@/assets/FAQGroup_SPU.png")
      : require("@/assets/FAQGroup.png");
  },

    async submit() {
      if (this.selectedOptions.length === 0) {
        this.$store.commit("onAlerting", {
          message_status: "กรุณาเลือกช่องทางที่รู้จักเรา",
          color: "#D1392B",
        });
        return;
      }

      this.showErrors = true;

      if (
        (this.selectedOptions.includes(7) && !this.additionalInfo.recommend) ||
        (this.selectedOptions.includes(8) && !this.additionalInfo.other)
      ) {
        return;
      }

      this.$store.commit("onLoading");

      try {
        let payload = {
          referral_source_id: [...this.selectedOptions],
          business_id: this.business_id,
        };

        if (this.selectedOptions.includes(7) && this.additionalInfo.recommend) {
          payload.referral_source_recommend =
            this.additionalInfo.recommend.trim();
        }

        if (this.selectedOptions.includes(8) && this.additionalInfo.other) {
          payload.referral_source_other = this.additionalInfo.other.trim();
        }

        const response = await this.$store.dispatch(
          "postBusinessUserReferral",
          payload
        );

        if (response) {
          this.internalDialog = false;
          this.resetForm();
          this.$store.commit("setReferralStatus", 1);
          this.$emit("submitSuccess");
        }
      } catch (err) {
        const errorMessage =
          err.response?.status === 400 ? "เกิดข้อผิดพลาด" : err.message;
        this.$store.commit("onAlerting", {
          message_status: errorMessage,
          color: "#D1392B",
        });
      } finally {
        this.$store.commit("offLoading");
      }
    },
    clearAdditionalInfo() {
      if (!this.selectedOptions.includes(7)) {
        this.additionalInfo.recommend = "";
      }
      if (!this.selectedOptions.includes(8)) {
        this.additionalInfo.other = "";
      }
    },
  },
  created() {
    this.$store.dispatch("fetchReferralSources");
  },
};
</script>

<style scoped>
.no-scroll {
  overflow: hidden !important;
}

.rounded-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.dialog-select {
  font-family: Noto Sans Thai !important;
}

.title-text {
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 20px;
  font-weight: bold;
}

.list-container {
  padding: 0 16px;
}

.list-container ::v-deep(.v-list-item) {
  min-height: 35px !important;
  padding: 0 !important;
}

.custom-checkbox {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
}

::v-deep(.v-input--selection-controls__input) {
  color: var(--v-bg_primary_register-base) !important;
}

.confirm-button {
  background-color: var(--v-bg_primary_register-base) !important;
  color: white !important;
  font-size: 16px;
  border-radius: 25px !important;
  width: 120px;
  height: 40px;
}

.custom-text-field-xs {
  width: 90px !important;
}

.custom-text-field-sm {
  width: 100px !important;
}

.custom-text-field-md {
  width: 110px !important;
}

.custom-text-field-lg {
  width: 120px !important;
}

.custom-text-field ::v-deep(.v-input__control) {
  border-radius: 10px !important;
  border: 1px solid #c4c4c4 !important;
  background-color: white !important;
}

.custom-text-field ::v-deep(.v-label) {
  font-size: 14px;
  color: #9e9e9e !important;
}

.error-text {
  font-size: 12px;
  color: red;
  margin-left: 10px;
}
</style>
